import type { MRT_Localization } from "material-react-table";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const useTableLocalization = () => {
	const { i18n } = useTranslation();
	const currentLocale = i18n.language.split("-")[0];
	const [localization, setLocalization] =
		useState<MRT_Localization>(MRT_Localization_EN);

	useEffect(() => {
		const loadLocalization = async () => {
			let localizationModule: MRT_Localization;
			switch (currentLocale) {
				case "cs":
					localizationModule = (await import("material-react-table/locales/cs"))
						.MRT_Localization_CS;
					break;
				case "en":
					localizationModule = (await import("material-react-table/locales/en"))
						.MRT_Localization_EN;
					break;
				case "es":
					localizationModule = (await import("material-react-table/locales/es"))
						.MRT_Localization_ES;
					break;
				default:
					localizationModule = MRT_Localization_EN;
			}
			setLocalization(localizationModule);
		};

		loadLocalization();
	}, [currentLocale]);

	return { localization };
};
